export default __webpack_public_path__ + "static/media/nxt.9e95935f.jpg";